import { Component, Inject, OnInit, Optional } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2WebpageLinkGet, P2WebpageItem, WebPageService } from '@app/services/web-page.service';

@Component({
    selector: 'tt-p2-webpage-link-edit',
    templateUrl: './p2-webpage-link-edit.component.html',
    styleUrls: ['./p2-webpage-link-edit.component.css'],
    standalone: false
})
export class P2WebpageLinkEditComponent implements OnInit {
    public page?: P2WebpageLinkGet;

    public webpages: P2WebpageItem[] = [];

    public saving = false;

    public readonly tabletSize: MediaQueryList;

    private navigator?: TTViewNavigator;

    constructor(
        private webPage: WebPageService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;

        this.saving = true;

        try {
            await this.webPage.saveP2WebpageLink(this.page);
            await this.navigator?.back();
        } catch {
            // Keep the editor open and unlock saving so the user can retry.
        } finally {
            this.saving = false;
        }
    }

    public ngOnInit(): void {
        const params = this.navigator?.params;
        const webpageKeyno = params?.['p2_webpage_keyno_belongto'];
        const linkKeyno = params?.['p2_webpagelink_keyno'];

        if (webpageKeyno === undefined || webpageKeyno === null || linkKeyno === undefined || linkKeyno === null) return;

        void this.loadPage(`${webpageKeyno}`, `${linkKeyno}`);
    }

    private async loadPage(webpageKeyno: string, linkKeyno: string): Promise<void> {
        const [page, webpages] = await Promise.all([
            this.webPage.getP2WebpageLink({
                p2_webpage_keyno_belongto: webpageKeyno,
                p2_webpagelink_keyno: linkKeyno,
            }),
            this.webPage.listP2Webpages()
        ]);

        this.page = page;
        this.webpages = webpages;
    }
}
